import isEmpty from 'lodash/fp/isEmpty'

const DEFAULT_ENDPOINT = 'https://picsum.photos'
const DEFAULT_VERSION = '2'

export type SearchOptions = {
  maxResults?: number
  page?: number
}

export type LoremPicsumItem = {
  author: string
  download_url: string
  height: number
  id: string
  url: string
  width: number
}
export type LoremPicsumResult = Array<LoremPicsumItem>

export type ImageSearchResult = {
  height: number
  url: string
  width: number
  description?: string
  parentPage?: string
  title?: string
}
export type SearchResult = ImageSearchResult
/** @public */
export type SearchResults = Array<SearchResult>

export class LoremPicsum {
  api: string

  defaultOptions: SearchOptions

  constructor(
    {
      endpoint = DEFAULT_ENDPOINT,
      version = DEFAULT_VERSION,
    }: {
      endpoint?: string
      version?: number | string
    } = {},
    defaultOptions: SearchOptions = {},
  ) {
    this.api = `${endpoint}/v${version}`
    this.defaultOptions = defaultOptions ?? {}
  }

  buildQuery(options: SearchOptions = {}) {
    const actualOptions = { ...this.defaultOptions, ...options }

    const queryObject: Record<string, string> = {}

    if (actualOptions?.page) {
      queryObject.page = String(actualOptions.page)
    }

    if (actualOptions?.maxResults) {
      queryObject.limit = String(actualOptions.maxResults)
    }

    return new URLSearchParams(queryObject).toString()
  }

  async list(options?: SearchOptions, abortSignal?: AbortSignal) {
    const url = `${this.api}/list?${this.buildQuery(options ?? {})}`
    const settings = { method: 'GET', signal: abortSignal }

    const response = await fetch(url, settings)
    if (!response.ok) {
      throw new Error('Failed to fetch the search results!')
    }

    const jsonResults: LoremPicsumResult = (await response.json()) ?? []
    if (isEmpty(jsonResults)) {
      return []
    }

    return jsonResults.map(
      (item): ImageSearchResult => ({
        description: item.author,
        height: item.height,
        parentPage: item.url,
        title: `#${item.id}`,
        url: item.download_url,
        width: item.width,
      }),
    )
  }
}
